import React, { useEffect, useState, useCallback } from "react";
import {
  Container,
  AppBar,
  Toolbar,
  CardMedia,
  Typography,
  List,
  ListItem,
  CircularProgress,
  Grid,
  TextField,
  Box,
} from "@mui/material";
import WorkIcon from "@mui/icons-material/Work";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useNavigate } from "react-router-dom";
import { isLoggedIn } from "../session";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import logoSvg from "../imgs/logo.png";
import BottomToolbar from "./BottomNav";

const DEFAULT_AVATAR = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect width="64" height="64" rx="12" fill="#161b2e"/><circle cx="32" cy="24" r="11" fill="#2a3a5c"/><ellipse cx="32" cy="54" rx="18" ry="12" fill="#2a3a5c"/></svg>')}`;

const Members = () => {
  const [users, setUsers] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [resultado, setResultados] = useState([]);
  const [loading, setLoading] = useState(true); // Inicializar loading como true

  const buscar = useCallback(() => {
    const valorBusqueda = busqueda.toLowerCase();
    const resultadosFiltrados = users.filter((user) =>
      user.displayName.toLowerCase().includes(valorBusqueda)
    );
    setResultados(resultadosFiltrados);
  }, [busqueda, users]);

  useEffect(() => {
    buscar();
  }, [buscar]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const isAuthenticated = await isLoggedIn();
        if (isAuthenticated) {
          // setLoading(true); // Ya está inicializado como true
          const usersCollection = collection(db, "users");
          const q = usersCollection;
          const usersSnapshot = await getDocs(q);

          // Verificar si hay resultados
          if (usersSnapshot.empty) {
            console.log("No se encontraron usuarios");
            setLoading(false); // Cambiar a false si no hay resultados
            return; // Salir de la función si no hay resultados
          }

          const usersData = usersSnapshot.docs.map((doc) => {
            const data = doc.data();
            return {
              key: doc.id,
              ...data,
              uid: data.uid,
              displayName: data.displayName,
              profession: data.profession,
              profileImageUrl: data.profileImageUrl,
              email: data.email,
              phone: data.phone,
              point: data.point,
            };
          });
          setUsers(usersData);
          setLoading(false); // Cambiar a false después de obtener los datos
          console.log("Usuarios obtenidas:", usersData);
        }
      } catch (error) {
        console.error("Error al obtener usuarios:", error);
        setLoading(false); // Cambiar a false en caso de error
      }
    };
    fetchUsers();
  }, []);

  let navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn()) {
      navigate("/login");
    }
  }, [navigate]);

  const styles = {
    cont: {
      position: "absolute",
      left: "50%",
      transform: "translateX(-50%)",
      textAlign: "center",
      margin: 0,
      padding: 0,
      boxSizing: "border-box",
    },
    img: {
      maxWidth: "165px",
      maxHeight: "40px",
      display: "block",
      margin: "20px auto",
    },
    slogan: {
      background: "linear-gradient(90deg, rgba(41,210,165,1) 31%, rgba(12,82,203,1) 62%)",
      WebkitBackgroundClip: "text",
      color: "transparent",
      fontSize: "12px",
      fontWeight: "bold",
      lineHeight: "19px",
    },
    iconContainer: {
      display: "flex",
      width: "100%",
      borderTop: "1.5px solid #30363d",
      justifyContent: "space-around",
      color: "#e6edf3",
    },
    backSlogan: {
      display: "block",
      width: "100vw",
      height: "19px",
      padding: "0px 0px 10px 0px",
      textAlign: "center",
    },
    listItem: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      width: "100%",
      border: "1px solid rgba(255,255,255,0.07)",
      borderRadius: "20px",
      padding: "14px 16px",
      margin: "8px 0",
      background: "rgba(255,255,255,0.03)",
      backdropFilter: "blur(8px)",
      transition: "all 0.22s ease",
    },
    typography: {
      marginBottom: "5px",
    },
    contList: {
      marginTop: "-30px",
    },
    inputS: {
      display: "block",
      width: "90vw",
      height: "30px",
      padding: "3px 0px 3px 20px",
      fontSize: "14px",
      border: "1px solid grey",
      borderRadius: "30px",
    },
    list: {
      display: "flex",
      flexDirection: "column",
      flexWrap: "wrap",
      alignItems: "center",
      width: "100%",
      marginTop: "15px"
    },
    media: {
      width: "160px",
      marginTop: "20px",
      marginBottom: "20px"
    },
    search: {
      width: "100%",
      marginBottom: "16px",
    },
  };

  return (
    <Container>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          width: "100%",
          height: "68px",
          background: "rgba(8,11,20,0.88)",
          backdropFilter: "blur(24px)",
          WebkitBackdropFilter: "blur(24px)",
          borderBottom: "1px solid rgba(255,255,255,0.08)",
          boxShadow: "0 4px 24px rgba(0,0,0,0.4)",
        }}
      >
        <Toolbar sx={{ height: "68px", px: 3, display: "flex", justifyContent: "space-between", alignItems: "center", minHeight: "68px !important" }}>
          <Box>
            <Typography sx={{ fontWeight: 800, fontSize: "1.45rem", lineHeight: 1.1, letterSpacing: "-0.5px", background: "linear-gradient(135deg, #00d4ff, #7b2ff7)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text" }}>
              FindMe
            </Typography>
            <Typography sx={{ fontSize: "0.6rem", color: "rgba(255,255,255,0.3)", letterSpacing: "2px", textTransform: "uppercase", mt: 0.2 }}>
              Buscar usuarios
            </Typography>
          </Box>
          <Box sx={{ width: 42, height: 42, borderRadius: "13px", background: "linear-gradient(135deg, rgba(0,212,255,0.18), rgba(123,47,247,0.18))", border: "1px solid rgba(0,212,255,0.28)", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 0 20px rgba(0,212,255,0.18)", overflow: "hidden" }}>
            <CardMedia component="img" image={logoSvg} title="FindMe" sx={{ width: 28, height: 28, objectFit: "contain" }} />
          </Box>
        </Toolbar>
      </AppBar>
      <Container sx={{ mt: "84px", pb: 12, px: 2 }}>
        <div style={styles.search}>
          <TextField
            label="Buscar usuarios..."
            variant="outlined"
            value={busqueda}
            fullWidth
            onChange={(e) => setBusqueda(e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "50px",
                background: "rgba(255,255,255,0.05)",
                "& fieldset": { borderColor: "rgba(255,255,255,0.1)" },
                "&:hover fieldset": { borderColor: "rgba(0,212,255,0.3)" },
                "&.Mui-focused fieldset": { borderColor: "#00d4ff", borderWidth: "1px" },
              },
              "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.4)" },
              "& .MuiInputLabel-root.Mui-focused": { color: "#00d4ff" },
              "& .MuiInputBase-input": { color: "#fff", padding: "12px 20px" },
            }}
          />
        </div>
        <div>
          {loading ? (
            <div style={{ textAlign: "center", color: "#58a6ff", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
              <CircularProgress />
            </div>
          ) : (
            <List style={styles.list}>
              {(resultado.length > 0 ? resultado : users).map((user) => (
                <ListItem
                  style={{ ...styles.listItem, cursor: "pointer" }}
                  key={user.key}
                  onClick={() => navigate(`/perfil/${user.uid}`)}
                >
                  <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
                    <CardMedia
                      component="img"
                      image={user.profileImageUrl || DEFAULT_AVATAR}
                      title="Perfil"
                      style={{
                        width: 52,
                        height: 52,
                        borderRadius: "14px",
                        marginRight: 14,
                        objectFit: "cover",
                        border: "2px solid rgba(0,212,255,0.2)",
                        boxShadow: "0 0 14px rgba(0,212,255,0.1)",
                        flexShrink: 0,
                      }}
                    />
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Typography sx={{ color: "#00d4ff", fontWeight: 700, fontSize: "0.97rem", mb: 0.4 }}>
                        {user.displayName}
                      </Typography>
                      {user.profession && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.7, mb: 0.2 }}>
                          <WorkIcon sx={{ fontSize: 13, color: "rgba(0,212,255,0.55)" }} />
                          <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.45)", fontSize: "0.8rem" }}>{user.profession}</Typography>
                        </Box>
                      )}
                      {user.email && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.7, mb: 0.2 }}>
                          <EmailIcon sx={{ fontSize: 13, color: "rgba(0,212,255,0.55)" }} />
                          <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.45)", fontSize: "0.8rem", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{user.email}</Typography>
                        </Box>
                      )}
                      {user.phone && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.7, mb: 0.2 }}>
                          <PhoneIcon sx={{ fontSize: 13, color: "rgba(0,212,255,0.55)" }} />
                          <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.45)", fontSize: "0.8rem" }}>{user.phone}</Typography>
                        </Box>
                      )}
                      {user.point && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.7 }}>
                          <LocationOnIcon sx={{ fontSize: 13, color: "rgba(0,212,255,0.55)" }} />
                          <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.45)", fontSize: "0.8rem" }}>{user.point}</Typography>
                        </Box>
                      )}
                    </Box>
                  </Box>
                </ListItem>
              ))}
            </List>
          )}
        </div>
      </Container>
      <BottomToolbar />
    </Container>
  );
};

export default Members;
